import {initTopBottom} from "../modulos/topbottom/topbottom";
import {laBolsaHoyModule} from "../modulos/laBolsaHoy/laBolsaHoy";
import analisisMasVistos from "../modulos/analisisMasVistos/analisisMasVistos";
import {photoSwipe} from "../modulos/photoswipe/photoswipe";
import Streaming from "../streaming/streaming";
import instrumentBox from "../modulos/instrumentBox/instrumentBox";

import {newsInfiniteScroll} from "../modulos/infiniteScrolling/newsInfiniteScrolling";
import {reloadAds} from "../marketing/publicidad";
import {loadNewsAlerts} from "../modulos/favoritos/favoritos";
import {sendVisitBeacon} from "../modulos/visitsAndPremiumStats/visitsAndPremiumStats";
import {sendContentGroups} from "../marketing/contentGroups";
import {sendPushInfiniteScroll} from "../marketing/gtm";
import {loadAdDoorPixel} from "../marketing/addoor";

import('./css/newsDetailPage.scss');

const loadEngagement = async (isPremium) => {
    if (isPremium) {
        // Comentarios. No AdDoor. No scroll.
        import('../modulos/foros/foros').then(forum => forum.loadForos())
    } else {
        loadAdDoorPixel()
            .catch(e => console.error(`addoor error: ${e}`))

        let pagesViewedWithInfinite = 0;
        const newsLoadedCallbackFn = () => {
            reloadAds();
            loadNewsAlerts();
        };
        const newsActiveCallbackFn = ({id, title, url, is_new}) => {
            if (is_new) {
                pagesViewedWithInfinite++;
                sendVisitBeacon();
                sendContentGroups();
                sendPushInfiniteScroll(pagesViewedWithInfinite);
            }
        }

        // Cargar scroll infinito
        newsInfiniteScroll({newsLoadedCallbackFn, newsActiveCallbackFn});
    }
}

export const newsDetailPage = () => {
    console.log('Loading newsDetail components');

    //Determinar si se trata de una noticia premium (a través de los estilos)
    const commentsHolder = document.querySelector('#comentarios')

    //Inicializar los top/flops
    initTopBottom(Streaming);

    //Inicializa InstrumentBox
    instrumentBox(Streaming);

    //Análisis más vistos
    analisisMasVistos();

    //La Bolsa Hoy Ajax (Módulo)
    laBolsaHoyModule();

    //PhotoSwipe. Galería para aumentar imágenes
    photoSwipe();

    // Cargar engagement: o Taboola o Scroll Infinito
    loadEngagement(!!commentsHolder);

    $(function(){

        //Mover publi si width < 400
        if (screen.width < 400) {
            $('#show-publi-1-into').insertAfter($('.article-body > p')[5]).show();
        }
        //Detectar si el usuario viene de la bolsa hoy para mostrar botón de vuelta
        if(document.referrer){
            if(document.referrer.indexOf('/actualidad/la-bolsa-hoy') > -1){
                $('#goBackBolsaHoy').html('<a href="'+document.referrer+'" class="form-button sk-wide">Volver a la Bolsa Hoy</a>');
            }
        }
        //Simular click si viene en el hash un trozo de vídeo
        if (window.location.hash) {
            var hash = window.location.hash.substr(1);
            if (hash) {
                app.$(function () {
                    app.$('.lnk-' + hash).trigger('click');
                });
            }
        }
        //Cargar formulario de inscripción en un curso si se detecta el campo
        const centerFormUrl = unmaskpath(JSVAR.base_url) + '/news/centerform/';
        $('div.centroForm').each(function(){
            var $item = $(this);
            var id = $item.data('idcenter');
            var name = $item.data('name');
            if(!id) return;
            $item.html('<div>Cargando formulario de '+name+'...</div>');
            $.ajax({
                url: unmaskpath(centerFormUrl+id),
                type: 'GET',
                success: function(html) {
                    return _handleFormSend(centerFormUrl+id, $item, html);
                },
                error: function(){
                    $item.remove();
                }
            });
        });
    });
}

function _handleFormSend(url, $item, html)
{
    $item.html(html);
    const $form = $item.find('form#usrFullProfile');
    $form.off().on('submit', function(e){
        e.preventDefault();
        $form.find('#CenterRequestInfo_send').attr('disabled', 'disabled');
        $.ajax({
            url: $form.attr('action'),
            type: 'POST',
            data: $form.serialize(),
            success: function(data){
                $item.html('<div style="border: 1px solid #207c23;\n' +
                    'padding: 5px;\n' +
                    'font-weight: bold;\n' +
                    'margin-top: 15px;\n' +
                    'background-color: rgba(32, 124, 35, 0.5);\n' +
                    'margin-bottom: 15px;border-radius: 5px">Se ha enviado correctamente su petición. El centro se podrá en contacto con usted próximamente.</div>');
                $('html,body').animate({
                    scrollTop: $item.offset().top - 150
                }, 'slow');
            },
            error: function(xhr, err){
                //El formulario ha sido devuelto con error. Realizar de nuevo el control AJAX
                return _handleFormSend(url, $item, xhr.responseText);
            }
        });
        return false;
    });
}
